import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  GetChannelAccessListRequestPayload,
  ChannelAccessListResponseOK,
  ChannelAccessListResponseError
} from '@repositories/api/statistics.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetChannelAccessListRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetChannelAccessListQuery<
  Data extends ChannelAccessListResponseOK,
  ErrorResponse extends ChannelAccessListResponseError
>({
  queryParams,
  options
}: Props<Data, ErrorResponse, ReturnType<typeof QUERY_KEY.STATISTICS.GET_CHANNEL_ACCESS_LIST>>) {
  return useQuery({
    queryKey: QUERY_KEY.STATISTICS.GET_CHANNEL_ACCESS_LIST({ queryParams }),
    queryFn: () => {
      return ApiRepository.statistics.getChannelAccessList({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetChannelAccessListQuery };
